import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * Получить данные специалиста по его ID
 */

@Injectable()
export class SpecialistService extends ApiService {
    protected baseUrl = 'specialist';
    public fireUrl = 'specialist/fire';  // Ссылка на "Увольнение" коллекции сотрудников

    /**
     * POST для генерации документа списка специалистов
     * Request Payload:
     * {
     *     ids: number[],
     *     format: number // 1 - просто список, 2 - архив со списком и доками
     * }
     */
    generateListDocumentUrl = this.baseUrl + '/generate-list-document';

    /**
     * GET Валидация и генерация документа "График аттестации персонала"
     */
    validateAttestationScheduleDocumentUrl = this.baseUrl + '/validate-attestation-schedule-document';
    generateAttestationScheduleDocumentUrl = this.baseUrl + '/generate-attestation-schedule-document';
}
